import React from 'react';

import config from '../../config';
import {
  ORDERBIRD_LEGAL_NOTICE_URL,
  ORDERBIRD_PRIVACY_POLICY_URL,
  ORDERBIRD_TERMS_CONDITIONS_URL,
  RESMIO_LEGAL_NOTICE_URL,
  RESMIO_PRIVACY_POLICY_URL,
  RESMIO_TERMS_CONDITIONS_B2C_URL,
  RESMIO_ACCESSIBILITY_URL,
} from 'app/constants';

import { PrivacyLink, PrivacyWrapper } from './styles/_privacyLinks';

const PrivacyLinks = () => (
  <PrivacyWrapper>
    <PrivacyLink
      href={
        config.isOrderbirdFacility
          ? ORDERBIRD_LEGAL_NOTICE_URL
          : RESMIO_LEGAL_NOTICE_URL
      }
      target="_blank"
    >
      {i18n.gettext('Legal Notice')}
    </PrivacyLink>
    {' | '}
    <PrivacyLink
      href={
        config.isOrderbirdFacility
          ? ORDERBIRD_PRIVACY_POLICY_URL
          : RESMIO_PRIVACY_POLICY_URL
      }
      target="_blank"
    >
      {i18n.gettext('Privacy Policy')}
    </PrivacyLink>
    {' | '}
    <PrivacyLink
      href={
        config.isOrderbirdFacility
          ? ORDERBIRD_TERMS_CONDITIONS_URL
          : RESMIO_TERMS_CONDITIONS_B2C_URL
      }
      target="_blank"
    >
      {i18n.gettext('Terms & Conditions')}
    </PrivacyLink>
    {' | '}
    <PrivacyLink href={RESMIO_ACCESSIBILITY_URL} target="_blank">
      {i18n.gettext('Accessibility')}
    </PrivacyLink>
  </PrivacyWrapper>
);

export default PrivacyLinks;
